import compressor from 'browser-image-compression';
import {
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from 'firebase/firestore';
import React, { useCallback, useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { Link } from 'react-router-dom';
import { v4 } from 'uuid';
import * as Yup from 'yup';
import { useAuth } from '~/hooks/auth';
import { useToast } from '~/hooks/toast';
import ICompany from '~/interfaces/ICompany';
import AWSBucket, { AWSParams } from '~/services/aws';
import { bff } from '~/services/bff';
import { DB } from '~/services/firebase';
import heroku from '~/services/heroku';
import getValidationErrors from '~/utils/getValidationErrors';
import InstallPWAButton from '~/components/InstallPWAButton';

interface SettingsAppProps {
  openMenu(): void;
}

const {
  REACT_APP_WEB_URL,
  REACT_APP_AWS_BUCKET_URL,
  REACT_APP_USE_API_PRODUCTS,
  REACT_APP_FIREBASE_PROJECT,
} = process.env;

const SettingsApp: React.FC<SettingsAppProps> = ({ openMenu }) => {
  const { user, company, updateCompany } = useAuth();
  const { addToast } = useToast();
  const [data, setData] = useState({} as ICompany);
  const [errors, setErrors] = useState({} as any);
  const [loading, setLoading] = useState(false);
  const [loadingUpdateProdcuts, setLoadingUpdateProducts] = useState(false);

  useEffect(() => {
    setData({
      ...company,
      app_color: company.app_color || '#000000',
    });

    const inputColor = document.getElementById('color') as any;
    if (inputColor && company.app_color) {
      inputColor.value = company.app_color;
    }
  }, [company]);

  // useEffect(() => {
  //   async function loadCompany() {
  //     const companiesRef = collection(DB, 'companies');
  //     const q = query(companiesRef, where('user_id', '==', user.uid));
  //     const querySnapshot = await getDocs(q);

  //     if (querySnapshot.docs.length > 0) {
  //       const aux = querySnapshot.docs[0].data() as ICompany;
  //       const item = {
  //         ...aux,
  //         uid: querySnapshot.docs[0].id,
  //       };

  //       setData(item);

  //       const inputColor = document.getElementById('color') as any;
  //       if (inputColor) {
  //         inputColor.value = item.app_color;
  //       }
  //     }
  //   }

  //   loadCompany();
  // }, [user.uid]);

  const handleCopyLink = useCallback(() => {
    const copyText = document.getElementById('link_compartilhavel') as any;

    if (copyText) {
      copyText.select();

      navigator.clipboard.writeText(copyText.value);
    }
  }, []);

  const handleSubmit = useCallback(
    async event => {
      event.preventDefault();

      try {
        const schema = Yup.object().shape({
          app_domain: Yup.string().required(
            'O campo domínio do aplicativo é obrigatório',
          ),
          app_color: Yup.string().required(
            'O campo cor principal é obrigatório',
          ),
        });

        await schema.validate(data, {
          abortEarly: false,
        });

        setLoading(true);

        const companiesRef = collection(DB, 'companies');
        const q = query(
          companiesRef,
          where('app_domain', '==', data.app_domain),
          where('uid', '!=', data.uid),
        );
        const querySnapshot = await getDocs(q);

        if (querySnapshot.docs.length > 0) {
          setLoading(false);
          setErrors({
            app_domain:
              'Esse domínio já está em uso. Por favor, escolha outro domínio.',
          });

          return;
        }

        const inputFileImage = document.getElementById(
          'photo',
        ) as HTMLInputElement;

        let logoImage = '';

        // if (
        //   inputFileImage &&
        //   inputFileImage.files &&
        //   inputFileImage.files.length > 0
        // ) {
        //   const file = inputFileImage.files[0];
        //   const storageRef = Storage.ref(`companies/${v4()}.png`);
        //   const resposne = await storageRef.put(file);
        //   logoImage = await resposne.ref.getDownloadURL();
        // }

        if (
          inputFileImage &&
          inputFileImage.files &&
          inputFileImage.files.length > 0
        ) {
          const file = inputFileImage.files[0];
          const filename = `${company.fantasy}-${company.uid}/${v4()}.png`;

          const compressedFile = await compressor(file, {
            maxSizeMB: 1,
            maxWidthOrHeight: 300,
            useWebWorker: true,
          });

          let config: any = {
            ...AWSParams,
            Body: compressedFile,
            Key: filename,
          };

          AWSBucket.putObject(config).send();

          if (data.uid && data.image) {
            const Key = data.image.replace(`${REACT_APP_AWS_BUCKET_URL}/`, '');
            config = {
              ...AWSParams,
              Key,
            };

            AWSBucket.deleteObject(config, (err, tmp) => {
              if (err) console.log(err);
              else console.log();
            });
          }

          logoImage = `${REACT_APP_AWS_BUCKET_URL}/${filename}`;
        }

        const inputFile = document.getElementById(
          'background',
        ) as HTMLInputElement;

        let app_background = '';

        // if (inputFile && inputFile.files && inputFile.files.length > 0) {
        //   const file = inputFile.files[0];
        //   const storageRef = Storage.ref(`app/${v4()}.png`);
        //   const resposne = await storageRef.put(file);
        //   app_background = await resposne.ref.getDownloadURL();
        // }

        if (inputFile && inputFile.files && inputFile.files.length > 0) {
          const file = inputFile.files[0];
          const filename = `${company.fantasy}-${company.uid}/${v4()}.png`;

          const compressedFile = await compressor(file, {
            maxSizeMB: 1,
            maxWidthOrHeight: 300,
            useWebWorker: true,
          });

          let config: any = {
            ...AWSParams,
            Body: compressedFile,
            Key: filename,
          };

          AWSBucket.putObject(config).send();

          if (data.uid && data.app_background) {
            const Key = data.app_background.replace(
              `${REACT_APP_AWS_BUCKET_URL}/`,
              '',
            );
            config = {
              ...AWSParams,
              Key,
            };

            AWSBucket.deleteObject(config, (err, tmp) => {
              if (err) console.log(err);
              else console.log();
            });
          }

          app_background = `${REACT_APP_AWS_BUCKET_URL}/${filename}`;
        }

        let parseData = {
          ...data,
          user_id: user.uid,
        } as ICompany;

        if (app_background) parseData = { ...parseData, app_background };
        if (logoImage) parseData = { ...parseData, image: logoImage };

        const uid = data.uid || v4();

        await setDoc(doc(DB, 'companies', uid), parseData);
        await bff.delete(`/companies/${REACT_APP_FIREBASE_PROJECT}`);
        updateCompany(parseData);

        addToast({
          type: 'success',
          description:
            'As configurações do aplicatico foram salvas com sucesso!',
        });

        setLoading(false);
      } catch (err: any) {
        console.log(err);
        setLoading(false);
        if (err instanceof Yup.ValidationError) {
          const parseErrors = getValidationErrors(err);
          setErrors(parseErrors);
          return;
        }

        addToast({
          type: 'danger',
          description:
            'Infelizmente não foi possível completar a operação. Por favor, Tente novamente.',
        });
      }
    },
    [data, user, addToast, updateCompany, company],
  );

  const handleUpdateProducts = useCallback(async () => {
    try {
      setLoadingUpdateProducts(true);
      await heroku.get('/clear');
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingUpdateProducts(false);
    }
  }, []);

  return (
    <div className="nk-block">
      <div className="nk-block-head nk-block-between">
        <div className="nk-block-head-content">
          <h5 className="nk-block-title">Aplicativo</h5>
          <div className="nk-block-des">
            <p>
              Personalize a visualização do aplicativo de vendas da sua empresa.
            </p>
          </div>
        </div>
        <div className="nk-block-head-content align-self-start d-lg-none">
          <Link
            to="#menu"
            className="toggle btn btn-icon btn-trigger mt-n1"
            data-target="userAside"
            onClick={openMenu}
          >
            <em className="icon ni ni-menu-alt-r" />
          </Link>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label htmlFor="dominio" className="form-label">
                Nome de Domínio do Aplicativo
              </label>
              <div className="form-control-wrap">
                <input
                  id="dominio"
                  type="text"
                  className="form-control form-control-lg"
                  placeholder="Domínio"
                  defaultValue={data.app_domain}
                  onChange={event => {
                    setData({
                      ...data,
                      app_domain: event.target.value,
                    });
                  }}
                />

                <span className="fs-9px">
                  * Nome de domínio do aplicativo para acessar via URL.
                </span>
                <br />
                {errors.app_domain && (
                  <span className="invalid">{errors.app_domain}</span>
                )}
              </div>
            </div>
          </div>
          {/* <div className="col-sm-6">
            <div className="form-group mb-3">
              <label
                htmlFor="background"
                className="form-label"
                style={{ width: '100%' }}
              >
                Background
                {data.app_background && (
                  <a
                    target="_blank"
                    href={data.app_background}
                    rel="noopener noreferrer"
                    className="ml-1"
                  >
                    Visualizar
                  </a>
                )}
              </label>
              <div className="form-control-wrap">
                <input id="background" type="file" style={{ width: '100%' }} />

                <br />

                <span className="fs-9px">
                  * Imagem de fundo no cabeçalho do aplicativo.
                </span>
              </div>
            </div>
          </div> */}

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label" style={{ width: '100%' }}>
                Imagem{' '}
                {data.image && (
                  <a
                    target="_blank"
                    href={data.image}
                    rel="noopener noreferrer"
                    className="ml-1"
                  >
                    Visualizar
                  </a>
                )}
              </label>
              <div className="form-control-wrap">
                <input type="file" id="photo" />
              </div>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label">Mensagem ao finalizar pedido</label>
              <div className="form-control-wrap">
                <textarea
                  className="form-control no-resize"
                  placeholder="Deixe uma mensagem para seus clientes quando finalizar um pedido."
                  defaultValue={data.order_finish_message}
                  onChange={event => {
                    setData({
                      ...data,
                      order_finish_message: event.target.value,
                    });
                  }}
                />
              </div>
              <p className="fs-9px mt-1">
                * Essa mensagem será exibida ao finalizar o pedido, apenas
                quando for realizado pelo cliente na mesa.
              </p>
            </div>
          </div>

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label htmlFor="color" className="form-label">
                Cor Principal
              </label>
              <div className="form-control-wrap">
                <input
                  id="color"
                  type="color"
                  className="form-control form-control-lg"
                  placeholder="Fantasia"
                  style={{ width: 140 }}
                  defaultValue={data.app_color}
                  onChange={event => {
                    setData({
                      ...data,
                      app_color: event.target.value,
                    });
                  }}
                />

                <span className="fs-9px">
                  * Cor principal para do aplicativo.
                </span>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="logo_format">
                Formato da logo?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="logo_format"
                    defaultValue={data.logo_format}
                    value={data.logo_format}
                    onChange={event => {
                      setData({
                        ...data,
                        logo_format: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Quadrado</option>
                    <option value="1">Círculo</option>
                  </select>
                  {errors.logo_format && (
                    <span className="invalid">{errors.logo_format}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="print_description">
                Imprimir a descrição do produto?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_description"
                    value={data.print_description}
                    onChange={event => {
                      setData({
                        ...data,
                        print_description: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  {errors.print_description && (
                    <span className="invalid">{errors.print_description}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="whatsapp_order">
                Notificar via whatsapp?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_description"
                    value={data.whatsapp_order}
                    onChange={event => {
                      setData({
                        ...data,
                        whatsapp_order: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  {errors.whatsapp_order && (
                    <span className="invalid">{errors.whatsapp_order}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="free_delivery">
                Promoção Entrega Grátis?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="free_delivery"
                    value={data.free_delivery}
                    onChange={event => {
                      setData({
                        ...data,
                        free_delivery: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                  {errors.free_delivery && (
                    <span className="invalid">{errors.free_delivery}</span>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="whatsapp_order">
                Impressão automática?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_description"
                    value={data.auto_print}
                    onChange={event => {
                      setData({
                        ...data,
                        auto_print: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim, Todos os pedidos</option>
                    <option value="2">Sim, Apenas pedidos delivery</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="whatsapp_order">
                Modelo da Impressora
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_description"
                    value={data.printer_model}
                    onChange={event => {
                      setData({
                        ...data,
                        printer_model: event.target.value,
                      });
                    }}
                  >
                    <option value="">Selecione...</option>
                    <option value="0">MPT-II</option>
                    <option value="1">P25 Blue Bamboo</option>
                    <option value="2">Mobile Printer</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="whatsapp_order">
                Adicionar 10% Opcional ao cupom?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_description"
                    value={data.percentage_optional}
                    onChange={event => {
                      setData({
                        ...data,
                        percentage_optional: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
                <p className="fs-9px mt-1">
                  * Configurar se deseja que seja impresso o valor opcional de
                  10% no cupom do pedido.
                </p>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="whatsapp_order">
                Troco obrigatório?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_description"
                    value={data.thing_required}
                    onChange={event => {
                      setData({
                        ...data,
                        thing_required: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
              </div>
              <p className="fs-9px mt-1">
                * Configurar se deseja que o cliente seja obrigado a informar um
                valor para troco.
              </p>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="print_payment_value">
                Imprimir valor a receber?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_payment_value"
                    value={data.print_payment_value}
                    onChange={event => {
                      setData({
                        ...data,
                        print_payment_value: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
              </div>
              <p className="fs-9px mt-1">
                * Configurar se deseja que o valor a receber seja impresso no
                cupom do pedido.
              </p>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="print_products">
                Imprimir produtos à parte?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_products"
                    value={data.print_products}
                    onChange={event => {
                      setData({
                        ...data,
                        print_products: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
              </div>
              <p className="fs-9px mt-1">
                * Configurar se deseja que seja impresso os produtos à parte
                para cortar e enviar para cozinha.
              </p>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="print_table_orders">
                Imprimir pedidos de mesa?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_table_orders"
                    value={data.print_table_orders}
                    onChange={event => {
                      setData({
                        ...data,
                        print_table_orders: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
                <p className="fs-9px mt-1">
                  * Configurar se deseja imprimir todo pedido de mesa que for
                  realizado.
                </p>
              </div>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label">Nome da impressora ESC/POS</label>
              <div className="form-control-wrap">
                <input
                  id="dominio"
                  type="text"
                  className="form-control form-control-lg"
                  defaultValue={data.escpos_printer}
                  value={data.escpos_printer}
                  onChange={event => {
                    setData({
                      ...data,
                      escpos_printer: event.target.value,
                    });
                  }}
                />
              </div>
              <p className="fs-9px mt-1">
                * Configurar o nome da impressora (epson) para imprimir
                utilizando o qz-tray.
              </p>
            </div>
          </div>

          <div className="col-sm-3">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="artistic_couvert_value">
                Valor do Couvert Artístico (por pessoa)
              </label>
              <div className="form-control-wrap">
                <input
                  id="artistic_couvert_value"
                  type="number"
                  step="0.01"
                  min="0"
                  className="form-control form-control-lg"
                  placeholder="0.00"
                  defaultValue={data.artistic_couvert_value || 0}
                  value={data.artistic_couvert_value || ''}
                  onChange={event => {
                    setData({
                      ...data,
                      artistic_couvert_value:
                        parseFloat(event.target.value) || 0,
                    });
                  }}
                />
              </div>
              <p className="fs-9px mt-1">
                * Valor a ser cobrado por pessoa como couvert artístico.
              </p>
            </div>
          </div>

          {/* <div className="col-sm-6">
            <div className="form-group mb-3">
              <label className="form-label" htmlFor="whatsapp_order">
                Imprimir segunda via dos pedidos?
              </label>
              <div className="form-control-wrap ">
                <div className="form-control-select">
                  <select
                    className="form-control form-control-lg"
                    id="print_description"
                    value={data.duplicate}
                    onChange={event => {
                      setData({
                        ...data,
                        duplicate: event.target.value,
                      });
                    }}
                  >
                    <option value="0">Não</option>
                    <option value="1">Sim</option>
                  </select>
                </div>
              </div>
            </div>
          </div> */}

          {/* <div className="col-sm-4">
            <div className="form-group mb-3">
              <label className="form-label">Instalar Aplicativo</label>
              <div className="form-control-wrap">
                <p className="text-muted mb-2 fs-9px">
                  Instale o aplicativo no seu dispositivo para acesso rápido.
                </p>
                <InstallPWAButtonStatic />
              </div>
            </div>
          </div> */}

          <div className="col-sm-6">
            <div className="form-group mb-3">
              <label htmlFor="link_compartilhavel" className="form-label">
                Link compartilhável
              </label>
              <div className="form-control-wrap">
                <div className="input-group">
                  <input
                    id="link_compartilhavel"
                    type="text"
                    readOnly
                    className="form-control form-control-lg"
                    placeholder="Domínio"
                    defaultValue={data.app_domain}
                    value={`${REACT_APP_WEB_URL}${data.app_domain}`}
                  />
                  <div className="input-group-append">
                    <button
                      type="button"
                      className="btn btn-outline-primary btn-dim"
                      onClick={handleCopyLink}
                    >
                      Copiar
                    </button>
                  </div>
                </div>

                <span className="fs-9px">
                  * Compartilhe esse link para os seus clientes acessarem a sua
                  loja.
                </span>
                <br />
                {errors.app_domain && (
                  <span className="invalid">{errors.app_domain}</span>
                )}
              </div>
            </div>
          </div>

          <div className="col-sm-4">
            <div className="form-group mb-3">
              <label htmlFor="qr_compartilhavel" className="form-label">
                QR Code Compartilhável
              </label>
              <div className="form-control-wrap">
                <QRCode value={`${REACT_APP_WEB_URL}${data.app_domain}`} />
              </div>
            </div>
          </div>

         

          <div className="col-12">
            <div className="form-group">
              <button
                type="submit"
                className="btn btn-lg btn-primary"
                disabled={loading}
              >
                {loading && (
                  <div
                    className="spinner-border spinner-border-sm"
                    role="status"
                  />
                )}
                {!loading && 'Salvar'}
              </button>

              {REACT_APP_USE_API_PRODUCTS && (
                <button
                  type="button"
                  className="btn btn-lg btn-secondary ms-2"
                  disabled={loadingUpdateProdcuts}
                  onClick={handleUpdateProducts}
                >
                  {loadingUpdateProdcuts && (
                    <div
                      className="spinner-border spinner-border-sm"
                      role="status"
                    />
                  )}
                  {!loadingUpdateProdcuts && 'Atualizar Produtos'}
                </button>
              )}
            </div>
          </div>
        </div>
      </form>

      {/* <InstallPWAButton position="right" /> */}
    </div>
  );
};

export default SettingsApp;
